import clone from 'lodash/clone';

export default class ShapeMemory {
  __shape;
  memory = {
    pos: {x: 0, y: 0},
    slabPos: {x: 0, y: 0},
    absolutePos: {x: 0, y: 0}
  };

  constructor(shape) {
    this.__shape = shape;
  }

  rememberShapePosition = () => {
    this.memory = {
      pos: clone(this.__shape.pos),
      slabPos: clone(this.__shape.slabPos),
      shapeSlabAbsolutePos: clone(this.__shape.shapeSlab.getAbsolutePosition()),
      shapeAbsolutePos: clone(this.__shape.shapeAbsolute.getAbsolutePosition())
    }
  }

  restoreShapePosition = () => {
    this.__shape.pos = clone(this.memory.pos)
    this.__shape.slabPos = clone(this.memory.slabPos)
    this.__shape.shapeSlab.setAbsolutePos( clone(this.memory.shapeSlabAbsolutePos));
    this.__shape.shapeAbsolute.setAbsolutePos( clone(this.memory.shapeAbsolutePos));
  }
}
